module.exports = __webpack_public_path__ + "static/img/blo8.6039610d.jpg";